import Numeral from 'numeral';
var DEFAULT_CURRENCY_FORMAT = '$0,0.00';
/**
 * Take a number or string and turn it into $1,000.00 format (USD Currency).
 * You can optionally pass the `format` to format the currency using which
 * will default to USD.
 */
export function asCurrency(balance, format) {
    if (format === void 0) { format = DEFAULT_CURRENCY_FORMAT; }
    return Numeral(balance).format(format);
}
/**
 * Take a number or string and turn it into $1,000 format (USD Currency).
 */
export function asWholeCurrency(balance) {
    return asCurrency(balance, '$0,0');
}
/**
 * Given a numeric string (formatted with `asCurrency`), this will return
 * the raw (numeric) value.
 */
export function rawValue(formattedValue) {
    return Numeral(formattedValue).value();
}
/**
 * Used with the useForm hook to take an input string value and return a
 * (USD Currency) formatted value as the user types by only accepting
 * "$", ".", and numbers. Also collapses successive "." and limits
 * precision to two decimal places.
 */
export function currencyInputFormatter(value) {
    if (value === void 0) { value = ''; }
    var cleanVal = value
        .replace(/\.+/g, '.') // Removes consecutive '.'
        .replace(/[^0-9.]/g, '') // Allows only [0-9] and '.'
        .replace(/^0{2,}(\d*)/, '0$1'); // Allows for just one leading 0
    // Check if cleanVal begins with '0.'
    var beginsWithZeroDot = !!/^0\./.exec(cleanVal);
    // If it doesn't, then strip any leading 0s from cleanVal
    if (!beginsWithZeroDot && cleanVal.length > 1) {
        cleanVal = cleanVal.replace(/^0*(\d*)/, '$1');
    }
    var matches = /^\$?(\d*)(\.\d{0,2})/g.exec(cleanVal) || cleanVal;
    return Array.isArray(matches) ? "" + matches[1] + matches[2] : matches;
}
/**
 * Used with the useForm hook to take an input string value and return a
 * (USD Currency) formatted value as the user types by filling in from the
 * right with cents. To input a whole dollar amount, user should finish by
 * typing 00.
 */
export function mobileCurrencyInputFormatter(value) {
    var cleanVal = value.replace(/[^0-9]*/g, '').replace(/^0*/g, '');
    if (cleanVal === '') {
        // Leave empty value as is to show placeholder
        return cleanVal;
    }
    if (cleanVal.length <= 2) {
        return "$0." + cleanVal.padStart(2, '00');
    }
    return cleanVal.replace(/^0*(\d*)(\d{2})/g, '$$$1.$2');
}
export default {
    rawValue: rawValue,
    asCurrency: asCurrency,
    asWholeCurrency: asWholeCurrency,
    currencyInputFormatter: currencyInputFormatter,
    mobileCurrencyInputFormatter: mobileCurrencyInputFormatter,
};
//# sourceMappingURL=format-currency.js.map